import {DailyAvailability} from "Interfaces/ResortResultInterface";
import {RoomModal, RoomInformation} from "Interfaces/RoomModalInterface";
import {ErrorModal} from "Interfaces/ErrorModalInterface";

const InitRoom: DailyAvailability = {
  room: "",
  roomTypeLabel: "",
  viewDescription: "",
  rateCode: "",
  pointAmount: 0,
  totaladjustedPoints: "",
  daily: [],
  roomPoolCode: "",
};

const InitRoomInformation: RoomInformation = {
  roomName: "",
  bedrooms: [],
  sleepCapacity: 0,
  // floorplanImg?: "/animage.jpeg"
};

const InitRoomModal: RoomModal = {
  show: false,
  room: Object.assign(InitRoomInformation),
};

const InitErrorModal: ErrorModal = {
  show: false,
  header: "",
  message: "",
};

export {
  InitRoom,
  InitRoomModal,
  InitErrorModal
};
